import React from 'react'
import { Outlet } from 'react-router-dom'

function MainBankCharges() {
  return (
    <div className='w-full h-full'>
        <Outlet/>
    </div>
  )
}

export default MainBankCharges